import otherLink from "./otherLink";
import searchCriteria from "./searchCriteria";
import notes from "./notes";
import metadata from "./metadata";

const output = { otherLink, searchCriteria, notes, metadata };

export default output;
